import get from 'lodash/get'
import { logSearchError } from '../../../../util/clientLogger'

// This object maps the smart weekend logic from original search to allowed days with Sat-Sun numbered as 0-6.
// So '50': ['40', '41', '51', '61'] would mean for original search of Fri-Sun allowed alt days are
// Thu-Sun(40), Thu-Mon(41), Fri-Mon(51), Sat-Mon(61)
const smartWeekendDates = {
  '50': ['40', '41', '51', '61'],
  '40': ['46', '41', '50', '51'],
  '51': ['46', '40', '41', '50'],
  '46': ['40', '41', '50', '51'],
  '41': ['40', '50', '51'],
  '60': ['50', '51', '61', '01'],
  '56': ['50', '51', '60', '61']
}

function parseDate(whatToParse, date) {
  const returnDate = {
    year: date.substring(0, 4),
    month: date.substring(5, 7) - 1,
    day: date.substring(8)
  }

  return returnDate[whatToParse]
}

// this function is to be cleaned up with SMART Weekend feature
export function isSmartWeekend(requestObj = {}) {
  if (get(requestObj, 'slices', []).length <= 1) {
    return false
  }

  const requestDepartDate = get(requestObj, 'slices[0].travelDate', '')
  const requestReturnDate = get(requestObj, 'slices[1].travelDate', '')

  if (requestDepartDate && requestReturnDate) {
    const requestDepartDay = new Date(
      parseDate('year', requestDepartDate),
      parseDate('month', requestDepartDate),
      parseDate('day', requestDepartDate)
    ).getDay()

    const requestReturnDay = new Date(
      parseDate('year', requestReturnDate),
      parseDate('month', requestReturnDate),
      parseDate('day', requestReturnDate)
    ).getDay()

    const requestDays = `${requestDepartDay}${requestReturnDay}`

    return !!smartWeekendDates[requestDays]
  }

  return false
}

export function smartWeekendFilter(itin, requestObj) {
  const { departDate, returnDate } = itin
  try {
    if (!returnDate || requestObj.slices.length <= 1) {
      return false
    }
    const requestDepartDate = requestObj.slices[0].travelDate
    const requestReturnDate = requestObj.slices[1].travelDate

    const requestDepartDay = new Date(
      parseDate('year', requestDepartDate),
      parseDate('month', requestDepartDate),
      parseDate('day', requestDepartDate)
    ).getDay()

    const requestReturnDay = new Date(
      parseDate('year', requestReturnDate),
      parseDate('month', requestReturnDate),
      parseDate('day', requestReturnDate)
    ).getDay()

    const departDay = new Date(
      parseDate('year', departDate),
      parseDate('month', departDate),
      parseDate('day', departDate)
    ).getDay()
    const returnDay = new Date(
      parseDate('year', returnDate),
      parseDate('month', returnDate),
      parseDate('day', returnDate)
    ).getDay()

    const requestDays = `${requestDepartDay}${requestReturnDay}`
    const responseDays = `${departDay}${returnDay}`
    return !(
      smartWeekendDates[requestDays] &&
      smartWeekendDates[requestDays].indexOf(responseDays) === -1
    )
  } catch (err) {
    logSearchError('Elastic search invalid Date: AWS Request Bad data', err)
    return false
  }
}
